module.exports = __webpack_public_path__ + "static/media/empty-instances.6aa1cff3.svg";